import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import restro from "../../../../assets/orderingSystem/restrologo.png";
import NumberWithCommas from "../../../../pages/Pages/Starter/NumberWithCommas";
import playBeep from "../../../PublicOrdering/pages/PlayBeep";

/**
 * ProductOptionsModal Component
 * Modal for customizing product with addons, notes, and quantity
 */
const ProductOptionsModal = ({
  isOpen,
  selectedProduct,
  selectedAddons,
  productNotes,
  productQty,
  onToggleAddon,
  onNotesChange,
  onQtyChange,
  onAddToCart,
  onClose,
}) => {
  const handleQtyDecrease = () => {
    playBeep();
    onQtyChange(Math.max(1, productQty - 1));
  };

  const handleQtyIncrease = () => {
    playBeep();
    onQtyChange(productQty + 1);
  };

  const handleAddToCart = () => {
    playBeep();
    onAddToCart();
  };

  const handleClose = () => {
    playBeep();
    onClose();
  };

  if (!selectedProduct) return null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader
        toggle={onClose}
        style={{
          fontWeight: "700",
          fontSize: "20px",
          borderBottom: "1px solid #000",
          borderRadius: "8px 8px 0 0",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {selectedProduct?.name || "Customize Item"}
      </ModalHeader>
      <ModalBody>
        <div>
          <div className="d-flex gap-3 mb-3">
            <img
              src={selectedProduct.displayImage?.getCDNUrl() || restro}
              alt={selectedProduct.name}
              style={{
                width: 90,
                height: 90,
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  className="fw-bold"
                  style={{
                    fontSize: "16px",
                    color: "#ff7900",
                    marginBottom: "4px",
                  }}
                >
                  Rs. <NumberWithCommas number={selectedProduct.price} />
                </div>
                {selectedProduct.originalPrice && (
                  <del style={{ fontSize: 11, color: "#aaa" }}>
                    Rs.{" "}
                    <NumberWithCommas
                      number={selectedProduct.originalPrice}
                    />
                  </del>
                )}
                <div style={{ fontSize: "12px", color: "#666" }}>
                  Subtotal:{" "}
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#ff7900",
                      fontSize: "14px",
                    }}
                  >
                    Rs.{" "}
                    <NumberWithCommas
                      number={selectedProduct.price * productQty}
                    />
                  </span>
                </div>
              </div>

              {/* Quantity Controls */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <button
                  onClick={handleQtyDecrease}
                  disabled={productQty <= 1}
                  style={{
                    width: "24px",
                    height: "24px",
                    border: "1px solid",
                    borderColor: productQty <= 1 ? "#ddd" : "#ff7900",
                    borderRadius: "6px",
                    background: productQty <= 1 ? "#f5f5f5" : "white",
                    color: productQty <= 1 ? "#999" : "#ff7900",
                    cursor: productQty <= 1 ? "not-allowed" : "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  −
                </button>

                <div
                  style={{
                    minWidth: "28px",
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  {productQty}
                </div>

                <button
                  onClick={handleQtyIncrease}
                  style={{
                    width: "24px",
                    height: "24px",
                    border: "none",
                    borderRadius: "6px",
                    background: "#ff7900",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Addons Section */}
          {(selectedProduct.addons || []).length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontWeight: 700, marginBottom: 8 }}>Addons</div>
              <div>
                {(selectedProduct.addons || []).map((a, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginBottom: 6,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedAddons.includes(idx)}
                      onChange={() => onToggleAddon(idx)}
                      style={{ cursor: "pointer" }}
                    />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600 }}>{a.name}</div>
                      <div style={{ fontSize: 12, color: "#666" }}>
                        Rs. <NumberWithCommas number={a.price} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Notes Section */}
          <FormGroup>
            <Label for="notes">Notes</Label>
            <Input
              type="textarea"
              id="notes"
              value={productNotes}
              onChange={(e) => onNotesChange(e.target.value)}
              placeholder="e.g., No onions, extra spicy, add cheese"
              style={{ minHeight: 80 }}
            />
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleAddToCart}
          style={{ backgroundColor: "#ff7900", border: "none" }}
        >
          Add to Cart
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProductOptionsModal;
